import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MultiSelectList from 'components/Fields/MultiSelectList';
import SelectMultiple from 'components/Fields/SelectMultiple';
import { t } from 'utils/getLiteral';
import Literal from 'components/literal';
class CrudMultiSelect extends PureComponent {
    componentDidUpdate(prevProps) {
        const { list, input } = this.props;
        if (list !== prevProps.list) {
            input.onChange([]);
        }
    }

    onChange = (value) => {
        const { input, onChange } = this.props;
        input.onChange(value);
        onChange(value);
    };

    render() {
        const {
            input,
            placeholder,
            readOnly,
            list,
            options = [],
            isDismissible,
            meta: { touched, error },
        } = this.props;
        let { value, onBlur } = input;

        const hasError = touched && error;

        const finalClassNames = [];
        if (hasError) {
            finalClassNames.push('has-error');
        }

        if (value && value[0] && typeof value[0] === 'object') {
            value = value.map((el) => el.id);
        }

        return (
            <div className={finalClassNames.join(' ')}>
                {list && list.length > 0 ? (
                    <MultiSelectList
                        value={value || []}
                        onBlur={(val) => onBlur(val.value)}
                        onChange={this.onChange}
                        labelMode="vertical"
                        label={null}
                        hint={placeholder ? t(placeholder) : null}
                        readOnly={readOnly}
                        list={list}
                        className={hasError ? 'input-error' : ''}
                    />
                ) : (
                    <SelectMultiple
                        value={value || []}
                        onBlur={(val) => onBlur(val.value)}
                        onChange={this.onChange}
                        labelMode="vertical"
                        label={null}
                        hint={placeholder ? t(placeholder) : null}
                        isDismissible={isDismissible}
                        readOnly={readOnly}
                        className={hasError ? 'input-error' : ''}
                        options={options}
                    />
                )}
                {hasError && (
                    <p className="crud-error-message">
                        <Literal literal="cfm_label_required_field" />
                    </p>
                )}
            </div>
        );
    }
}

CrudMultiSelect.propTypes = {
    input: PropTypes.shape({}).isRequired,
    list: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ),
};

export default CrudMultiSelect;
